import React, { useState } from 'react';
import { FileText, Megaphone, Star, ChevronRight } from 'lucide-react';
import ArticlesManager    from './content/ArticlesManager';
import AdvertisingManager from './content/AdvertisingManager';
import SponsorsManager    from './content/SponsorsManager';

const SECTIONS = (t) => [
  { key: 'articles',    label: t.cm_articles,    icon: FileText  },
  { key: 'advertising', label: t.cm_advertising, icon: Megaphone },
  { key: 'sponsors',    label: t.cm_sponsors,    icon: Star      },
];

const ContentManagementTab = ({ subEventId, orgHeaders, t }) => {
  const [active, setActive] = useState('articles');

  const sections = SECTIONS(t);

  return (
    <div className="flex gap-6 min-h-[600px]">

      {/* ── Sidebar ── */}
      <aside className="w-52 flex-shrink-0">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
          <div className="px-4 py-3 border-b border-gray-100">
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">{t.tab_content}</p>
          </div>
          <nav className="py-2">
            {sections.map(({ key, label, icon: Icon }) => (
              <button
                key={key}
                onClick={() => setActive(key)}
                className={`w-full flex items-center gap-3 px-4 py-2.5 text-sm font-medium transition-colors ${
                  active === key
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                }`}
              >
                <Icon size={15} className="flex-shrink-0" />
                <span className="flex-1 text-left">{label}</span>
                {active === key && <ChevronRight size={13} className="text-blue-400" />}
              </button>
            ))}
          </nav>
        </div>
      </aside>

      {/* ── Content area ── */}
      <div className="flex-1 min-w-0">
        {active === 'articles'    && <ArticlesManager    subEventId={subEventId} orgHeaders={orgHeaders} t={t} />}
        {active === 'advertising' && <AdvertisingManager subEventId={subEventId} orgHeaders={orgHeaders} t={t} />}
        {active === 'sponsors'    && <SponsorsManager    subEventId={subEventId} orgHeaders={orgHeaders} t={t} />}
      </div>
    </div>
  );
};

export default ContentManagementTab;
